// extracted by mini-css-extract-plugin
module.exports = {"header":"recommendations_header__3HACt","cartHeader":"recommendations_cartHeader__bdqdn","row":"recommendations_row__vD2hD","button":"recommendations_button__GWRRX"};